<template>
  <v-container id="grupomodificadores" tag="section">
    <base-v-component heading="Modificadores del Negocio " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click="goAdd()"
          >Añadir Modificadores</v-btn
        >
        <v-btn
          v-if="isAdmin"
          :loading="loadingTraducir"
          color="secondary"
          dark
          outlined
          small
          class="mb-2 mx-4"
          @click="traducirLoQueSeVe()"
          >Traducir lo que se ve
          <v-icon class="ml-1" small>mdi-google-translate</v-icon></v-btn
        >
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer />
        <v-btn color="success" @click="getModificadores()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="modificadores"
        :loading="loading"
        :search="search"
      >
        <template v-slot:item.acciones="{ item }">
          <v-spacer></v-spacer>
          <v-btn
            @click="goEdit(item)"
            class="px-2 ml-1"
            color="secondary"
            min-width="0"
            small
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click="deleteItem(item)"
            class="px-2 ml-1"
            color="red"
            min-width="0"
            :loading="loadingBorrar"
            small
          >
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { mostrarIdioma } from "@/utils/utils.js";
export default {
  data() {
    return {
      loadingTraducir: false,
      loadingBorrar: false,
      loading: false,
      search: "",
      headers: [
        {
          text: "Nombre",
          value: "nombreMostrar",
        },
        {
          text: "Desc interna",
          value: "descripcionInterna",
        },
        {
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      modificadoresBruto: (state) => state.productos.modificadores,
    }),
    ...mapGetters({
      isAdmin: "auth/isAdmin",

      negocio: "app/negocioGestObj",
    }),
    modificadores() {
      return this.modificadoresBruto.map((m) => {
        return { ...m, nombreMostrar: mostrarIdioma(m.nombre) };
      });
    },
  },
  methods: {
    async traducirLoQueSeVe() {
      var i = 0;
      this.loadingTraducir = true;
      console.log(this.modificadores);
      while (i < this.modificadores.length) {
        console.log(i);
        let traducir = this.modificadores
          .slice(i, i + 10)
          .map((prd) => {
            return [
              {
                id: prd.id,
                key: "nombre",
                texto: prd.nombre,
              },
              {
                id: prd.id,
                key: "descripcion",
                texto: prd.descripcion,
              },
            ];
          })
          .flat();
        await this.$store
          .dispatch("traducir", traducir)
          .then((r) => {
            console.log(_.groupBy(r, "id"));
            let agrupados = _.groupBy(r, "id");
            var promesas = [];
            for (let prop in agrupados) {
              let propDinamicas = {};
              agrupados[prop].forEach((p) => {
                propDinamicas[p.key] = p.texto;
              });
              console.log(agrupados);
              let objGuardar = {
                id: prop,
                ...propDinamicas,
              };
              console.log(objGuardar);
              promesas.push(
                this.$store
                  .dispatch("productos/addModificador", {
                    ...objGuardar,
                  })
                  .catch((e) => console.log(e))
              );
            }
            return Promise.all(promesas);
          })
          .finally(() => {
            console.log("primer fin");
          });
        i = i + 10;
      }
      this.getModificadores();
      this.loadingTraducir = false;
    },
    deleteItem(item) {
      var _vm = this;
      this.$confirm(
        "¿Desea eliminar este modificador? Esta acción es irreversible?",
        {
          buttonTrueText: "Aceptar",
          buttonFalseText: "No",
          color: "warning",
          icon: "warning",
          width: 350,
        }
      ).then((res) => {
        if (res) {
          _vm.loadingBorrar = true;
          return this.$store
            .dispatch("productos/deleteModificador", item)
            .then((res) => {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Modificador borrado con éxito",
              });
              return _vm.getModificadores();
            })
            .catch((error) => {
              console.log(error);
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al borrar el modificador " + error,
              });
            })
            .finally(() => {
              _vm.loadingBorrar = false;
            });
        }
      });
    },
    getModificadores() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch("productos/getModificadores").finally(() => {
        _vm.loading = false;
      });
    },
    goAdd() {
      let str =
        "/admin/gest/" + this.negocio.id + "/almacen/modificadores/form";
      this.$router.push(str);
    },
    goEdit(item) {
      let str =
        "/admin/gest/" +
        this.negocio.id +
        "/almacen/modificadores/form/" +
        item.id;
      this.$router.push(str);
    },
  },
  mounted() {
    this.getModificadores();
  },
};
</script>

<style>
</style>